import React, { useState, useContext } from 'react';
import { Button, Alert, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMutation, gql } from '@apollo/client';
import { AuthContext } from '../context/AuthContext';
import AuthShell from '../components/AuthShell';
import { FormTextField } from '../components/AuthFields';
import PasswordField from '../components/AuthFields';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';

const TOKEN_AUTH_MUTATION = gql`
  mutation TokenAuth($username: String!, $password: String!) {
    tokenAuth(username: $username, password: $password) {
      token
      refreshToken
    }
  }
`;

const VALUE_BULLETS = [
  { icon: BoltRoundedIcon, text: 'Sincronización automática con tu banco' },
  { icon: CategoryRoundedIcon, text: 'Categorización táctil en segundos' },
  { icon: InsightsRoundedIcon, text: 'Dashboard visual de tus gastos' },
];

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const [tokenAuth, { loading }] = useMutation(TOKEN_AUTH_MUTATION);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const { data } = await tokenAuth({
        variables: { username, password },
      });

      if (data.tokenAuth.token) {
        login(data.tokenAuth.token, data.tokenAuth.refreshToken, { username });
        navigate('/dashboard');
      }
    } catch (err) {
      setError('Usuario o contraseña incorrectos');
    }
  };

  return (
    <AuthShell
      overline="BIENVENIDO DE VUELTA"
      title="Inicia"
      titleAccent="sesión"
      subtitle="Ingresa para ver tus movimientos y clasificar transacciones."
      bullets={VALUE_BULLETS}
      trustChip={{
        icon: <BoltRoundedIcon />,
        label: 'Zort sincroniza cada hora',
      }}
      footer={{
        text: '¿No tienes cuenta?',
        label: 'Crear cuenta',
        to: '/register',
      }}
    >
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <FormTextField
            fullWidth
            label="Usuario"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            icon={PersonRoundedIcon}
            required
          />
          <PasswordField
            fullWidth
            label="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            icon={LockRoundedIcon}
            required
          />
          <Button
            fullWidth
            variant="contained"
            color="secondary"
            size="large"
            type="submit"
            disabled={loading}
          >
            {loading ? 'Ingresando...' : 'Iniciar sesión'}
          </Button>
        </Stack>
      </form>
    </AuthShell>
  );
};

export default Login;